import type { Issue } from '../api/types'

/** Row-level problems from an import, shown before anything is committed. */
export default function IssueTable({ issues }: { issues: Issue[] }) {
  if (issues.length === 0) return null
  return (
    <div className="table-wrap" style={{ maxHeight: 320, overflow: 'auto' }}>
      <table>
        <thead><tr><th className="num">Row</th><th>Column</th><th>Problem</th></tr></thead>
        <tbody>{issues.map((i, n) => <tr key={n}><td className="num">{i.row === 0 ? 'File' : i.row}</td><td>{i.column ?? '—'}</td><td>{i.message}</td></tr>)}</tbody>
      </table>
    </div>
  )
}
